import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOrganizations } from 'app/entities/organization/organization.reducer';
import { createEntity, getEntity, reset, updateEntity } from './organization-workflow.reducer';

export const OrganizationWorkflowUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const organizations = useAppSelector(state => state.organization.entities);
  const organizationWorkflowEntity = useAppSelector(state => state.organizationWorkflow.entity);
  const loading = useAppSelector(state => state.organizationWorkflow.loading);
  const updating = useAppSelector(state => state.organizationWorkflow.updating);
  const updateSuccess = useAppSelector(state => state.organizationWorkflow.updateSuccess);

  const handleClose = () => {
    navigate(`/organization-workflow${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOrganizations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...organizationWorkflowEntity,
      ...values,
      organization: organizations.find(it => it.id.toString() === values.organization?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...organizationWorkflowEntity,
          organization: organizationWorkflowEntity?.organization?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.organizationWorkflow.home.createOrEditLabel" data-cy="OrganizationWorkflowCreateUpdateHeading">
            <Translate contentKey="tycheApp.organizationWorkflow.home.createOrEditLabel">Create or edit a OrganizationWorkflow</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="organization-workflow-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.organizationWorkflow.key')}
                id="organization-workflow-key"
                name="key"
                data-cy="key"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.organizationWorkflow.flowUrl')}
                id="organization-workflow-flowUrl"
                name="flowUrl"
                data-cy="flowUrl"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.organizationWorkflow.flowContent')}
                id="organization-workflow-flowContent"
                name="flowContent"
                data-cy="flowContent"
                type="text"
              />
              <ValidatedField
                id="organization-workflow-organization"
                name="organization"
                data-cy="organization"
                label={translate('tycheApp.organizationWorkflow.organization')}
                type="select"
              >
                <option value="" key="0" />
                {organizations
                  ? organizations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/organization-workflow" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OrganizationWorkflowUpdate;
